module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('DashCard', {
    attrs: {
      "value": _vm.trafficTotal,
      "label": _vm.$t('statistic.traffic'),
      "icon": "users"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('DashCard', {
    attrs: {
      "value": _vm.approvedTotal,
      "label": _vm.$t('statistic.approve'),
      "icon": "thumbs-o-up",
      "bg": "success"
    }
  }, [_c('template', {
    slot: "percents"
  }, [_c('small', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(_vm.approvedPercents))])])], 2)], 1), _vm._v(" "), (_vm.Auth.haveAccess('DASH_ADVERTISE_DEBIT')) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('DashCard', {
    attrs: {
      "value": (_vm.adverticeDebit + "$"),
      "label": _vm.$t('statistic.debt'),
      "icon": "hand-lizard-o"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('TrafficChart', {
    attrs: {
      "chartData": _vm.trafficChart
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-6 col-md-6 col-xs-12 otherResponsive"
  }, [_c('DifferencyTable', {
    attrs: {
      "tableData": _vm.averageBillTable,
      "title": _vm.$t('statistic.averageBill'),
      "symbol": "$",
      "icon": "usd",
      "calculate": true,
      "withAverage": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 col-md-6 col-xs-12 otherResponsive"
  }, [_c('DifferencyTable', {
    attrs: {
      "tableData": _vm.approveTable,
      "title": _vm.$t('statistic.approve'),
      "symbol": "%",
      "color": "warning",
      "icon": "thumbs-o-up",
      "calculate": true,
      "withAverage": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 col-md-12 col-xs-12 leadsResponsive"
  }, [_c('DifferencyTable', {
    attrs: {
      "isLeads": true,
      "tableData": _vm.leadsForDash,
      "title": _vm.$t('statistic.leads'),
      "color": "success",
      "icon": "users",
      "calculate": true
    }
  }), _vm._v("`\n        ")], 1), _vm._v(" "), (_vm.Auth.haveAccess('DASH_ADVERTISE_DEBIT')) ? _c('div', {
    staticClass: "col-xl-12 col-md-12 col-xs-12"
  }, [_c('DebitTable', {
    attrs: {
      "tableData": _vm.adverticeDbt,
      "title": _vm.$t('statistic.debt'),
      "color": "primary",
      "icon": "hand-lizard-o"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30c3b954"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = 536
// module chunks = 0